import {
  Component,
  OnInit,
  ElementRef,
  Renderer2,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AuthserviceService } from 'src/app/services/authservice.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.css',
})
export class DeleteAccountComponent implements OnInit, AfterViewInit {
  otpValues: string[] = ['', '', '', '', '', ''];
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  queryParams: any;
  name: any;
  token: any;
  slug_id:string = ''
  submited: any = false;
  message: boolean = false;
  delete_account_message: boolean = false;
  char_message: boolean = false;
  unauthorised:boolean = false
  somethingWentWrong:boolean = false
  constructor(
    private router: Router,
    private _auth: AuthserviceService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private storage: StorageService
  ) {}
  ngOnInit(): void {
    this.get_delete_account_messages();
    this.get_query_params();
  }
  ngAfterViewInit() {
    // Focus on the first input when the component is initialized
    if (this.otpInputs && this.otpInputs.length > 0) {
      this.renderer
        .selectRootElement(this.otpInputs.toArray()[0].nativeElement)
        .focus();
    }
  }

  async onSubmit() {
    this.delete_account_message = false
    this.unauthorised = false
    this.char_message = false;
    this.somethingWentWrong = false
    this.submited = true;
    try {
      // Get query params and decrypt email
      await this.get_query_params();
      // Concatenate OTP values to get the complete OTP
      const otp = this.otpValues.join('');
      if (!otp) {
        this.message = true;
        this.delete_account_message = false;
        return;
      }
      if (!/^\d+$/.test(otp)) {
        // If OTP contains non-numeric characters, break out of the function
        this.char_message = true;
        this.submited = false;
        this.delete_account_message = false;
        return;
      }
      // Execute reCAPTCHA and get token
      const token = await this.recaptchaV3Service
        .execute('importantAction')
        .toPromise();
      if (token && otp) {
        // Prepare user details for account deletion
        const user_details = { token: this.token, otp: otp ,slug_id:this.slug_id};
        // Delete account
        const response = await this._auth.delete_account(user_details, token)
        if (response?.success){
          this.router.navigate(['account/delete/success']);
          this.submited = false;
          return 
        }else if (response?.responseCode == 403){
          this.delete_account_message = true
          this.submited = false; 
        }else if (response?.responseCode == 422){
          this.unauthorised = true
          this.submited = false
          return
        }else if(response?.responseCode == 500){
          this.somethingWentWrong = true
          this.submited =false
          return
        }
       
      }
    } catch (error) {
      // Handle errors, e.g., show an error message or navigate to an error page
      console.error('Error during account deletion:', error);
      this.submited = false;
      this.router.navigate(['error']);
    }
  }

  async get_query_params() {
    return new Promise<void>((resolve, reject) => {
      this.route.queryParams.subscribe(async (queryParams: any) => {
        try {
          // Access the names and values dynamically
          const decodedParam = queryParams['params']
          this.token = decodedParam
          this.slug_id = queryParams['slug']
          resolve();
        } catch (error) {
          console.error('Error during decryption:', error);
          reject(error);
        }
      });
    });
  }

  redirect_request_page() {
    this.router.navigate(['/account/delete/request']);
  }

  onKeyDown(event: any, index: number) {
    // Allow only numeric keys and exclude control keys
    if (/^\d$/.test(event.key)) {
      event.preventDefault();
      this.otpValues[index] = event.key;
      this.focusNextInput(index);
    } else if (event.key === 'Backspace' && index > 0) {
      event.preventDefault();
      this.otpValues[index] = '';
      this.focusPreviousInput(index);
    }
  }

  private focusNextInput(index: number) {
    if (this.otpInputs && index < this.otpInputs.length - 1) {
      this.renderer
        .selectRootElement(this.otpInputs.toArray()[index + 1].nativeElement)
        .focus();
    }
  }

  private focusPreviousInput(index: number) {
    if (this.otpInputs && index > 0) {
      this.renderer
        .selectRootElement(this.otpInputs.toArray()[index - 1].nativeElement)
        .focus();
    }
  }

  get_delete_account_messages() {
    const message = this.storage.getFromLocalStorage('message');
    if (message && message.toLowerCase() == 'action restricted') {
      this.delete_account_message = true;
    }
  }
}
